import { Navigate } from 'react-router-dom';
import { AiHub as HostbuddyAiHub } from '@hostbuddy-frontend-dev/inbox';
import Loader from 'components/loader/Loader';
import useHostfullyAssist from 'pages/hostfullyAssist/useHostfullyAssist';
import { hostbuddyApiBaseUrl, hostbuddyApiKey } from './HostbuddyAI.constants';

const AiHub = () => {
  const { isAssistEligible, isAssistActive, isLoading, assistMenuEntryPath } =
    useHostfullyAssist();

  if (isLoading) {
    return <Loader />;
  }

  if (!isAssistEligible) {
    return <Navigate to="/integrations" replace />;
  }

  if (!isAssistActive) {
    return <Navigate to={assistMenuEntryPath} replace />;
  }

  return <HostbuddyAiHub config={{ hostbuddyApiBaseUrl, hostbuddyApiKey }} />;
};

export default AiHub;
